import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Overlay from 'components/Overlay';

const Loading = ({
  backgroundUrl,
  theme,
  sharedTheme,
  children,
  innerContainerChildren,
  rendered,
  backgroundClass,
  innerContainerChildrenParams,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    sharedTheme={sharedTheme}
    theme={theme}
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
    innerContainerChildrenParams={innerContainerChildrenParams}
  >
    {children}
  </Overlay>
);

Loading.defaultProps = {
  backgroundUrl: null,
  sharedTheme: {},
};

Loading.propTypes = {
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  innerContainerChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

Loading.defaultProps = {
  backgroundClass: '',
  backgroundUrl: '',
  children: null,
  innerContainerChildren: noop,
  innerContainerChildrenParams: {},
  rendered: PropTypes.bool,
  sharedTheme: null,
  theme: null,
};

export default Loading;
